export class CustomParamsReferralStatTracUserModel {
  CallID: string;
  User: number;
}
